import type {
  BatchGetAggregatesRequest,
  BatchGetAggregatesResponse,
  BatchUpdateAggregatesRequest,
  BatchUpdateAggregatesResponse,
  ResolveAggregateSensitiveDataRequest,
  ResolveAggregateSensitiveDataResponse,
  SendAggregateRequest,
  SendAggregateResponse,
} from '@blk/aladdin-graph-client-axios-internal/wealth/portfolio_management/portfolios/v1/aggregate_api';
import type { Mandate } from '@blk/aladdin-graph-client-axios-internal/wealth/portfolio_management/portfolios/v1/mandate_api';
import { awPortfolioManagementApi } from './Base';
import {
  AgraphGetAggregatesRequestBody,
  AgraphGetAggregatesResponseBody,
  BatchDeleteAggregatesRequestBody,
} from './types';

const AGGREGATES_PATH = 'portfolios/v1/aggregates';

export function postSendAggregates(request: SendAggregateRequest) {
  const path = `${AGGREGATES_PATH}:send`;
  return awPortfolioManagementApi.post<SendAggregateResponse>(path, request);
}

export function postBatchGetAggregates(getAggregatesRequest: BatchGetAggregatesRequest) {
  const path = `${AGGREGATES_PATH}:batchGet`;
  return awPortfolioManagementApi.post<BatchGetAggregatesResponse>(path, getAggregatesRequest);
}

export function postGetAggregates(getAggregatesRequest: AgraphGetAggregatesRequestBody) {
  const path = `${AGGREGATES_PATH}:batchGet`;
  return awPortfolioManagementApi.post<AgraphGetAggregatesResponseBody>(path, getAggregatesRequest);
}

export function postBatchDeleteAggregates(batchDeleteAggregatesRequest: BatchDeleteAggregatesRequestBody) {
  const path = `${AGGREGATES_PATH}:batchDelete`;
  return awPortfolioManagementApi.post<void>(path, batchDeleteAggregatesRequest);
}

export function resolveAggregateSensitiveData(payload: ResolveAggregateSensitiveDataRequest) {
  const path = `${AGGREGATES_PATH}:resolveSensitiveData`;
  return awPortfolioManagementApi.post<ResolveAggregateSensitiveDataResponse>(path, payload);
}

export function updateAggregateMandate(mandate: Mandate) {
  const aggregateTag = mandate.parentReference?.aggregate?.tag;
  const aggregateId = mandate.parentReference?.aggregate?.id;
  const path = `${AGGREGATES_PATH}/${aggregateTag}/${aggregateId}/mandate`;
  return awPortfolioManagementApi.put<Mandate>(path, mandate);
}

export function batchUpdateAggregates(request: BatchUpdateAggregatesRequest) {
  const path = `${AGGREGATES_PATH}:batchUpdate`;
  return awPortfolioManagementApi.post<BatchUpdateAggregatesResponse>(path, request);
}
